import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpInterceptor,
  HttpHandler,
  HttpEvent
} from "@angular/common/http";

import { Observable } from "rxjs";
import { environment } from 'src/environments/environment';
import { I18nService } from 'src/app/core/i18n';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private i18n: I18nService){ }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = localStorage.getItem("token");
    const jwt = localStorage.getItem("jwt");
    const ignoredRequests = [
      environment.trialKitRequestUrl,
      environment.trustpilotReviewUrl,
      environment.newLeadRequestUrlIT,
      environment.newLeadRequestUrlGB,
      environment.newLeadRequestUrlUS,
      environment.resellingApi,
      environment.kpiEmail,
      'assets/i18n/'            // exclude translation files

    ];
    const isRequestIgnored = ignoredRequests.filter(r => request.url.includes(r) ).length !== 0;
    if (token) {
      if (isRequestIgnored) {
        return next.handle(request);
      } else {
        const clonedRequest = request.clone({
          headers: request.headers
            .set("Authorization", "Bearer " + token)
            .set("Voverc-jwt-auth", jwt)
            .set("Accept-Language", this.i18n.language)
        });
        return next.handle(clonedRequest);
      }
    } else {
      return next.handle(
        request.clone({
          headers: request.headers.set("Accept-Language", "it")
        })
      );
    }
  }
}
